<template>
  <client-only>
    <div
      data-test-id="component-cookie-banner"
    >
      <SharedGenericBanner cookie-name="cookieBannerViewed" addon-class="fixed bottom-0 shadow-banner z-50" bg-class="bg-light-green">
        <template #default="{close}">
          <div class="container flex items-center">
            <button
              class="flex items-center justify-center outline-none mr-4"
              data-test-id="button-cookie-banner-close"
              aria-label="Close icon"
              @click="close"
            >
              <MajorityUiMajorityIcon icon="close" class="flex items-center justify-center text-tiny text-dusty-gray opacity-75 font-light" />
            </button>
            <p class="m-0 text-tiny md:text-smallest leading-tight select-none text-dusty-gray font-light opacity-75" v-html="cookieMessage" />
          </div>
        </template>
      </SharedGenericBanner>
    </div>
  </client-only>
</template>

<script>
export default {
  data () {
    return {
      cookieName: 'cookieBannerViewed',
      cookieMessage: ''
    }
  },
  created () {
    const link = this.$mRouter.getLocalRoute({ name: 'terms-of-use-slug', params: { slug: this.$i18n.locale === 'es' ? 'politica-de-privacidad' : 'privacy-policy' } }).href
    this.cookieMessage = this.$messages('shared.cookie_banner', { link, classes: 'font-medium' })
  }
}
</script>
